import { useAiSearchContext } from '../../contexts/AiSearchContext';
import { AiSearchChip } from './AiSearchChip';

export const AiGeneratingChip = () => {
  const { setIsAiSearchLoading, abortControllerRef } = useAiSearchContext();

  const handleStop = () => {
    abortControllerRef.current?.abort();
    setIsAiSearchLoading(false);
  };

  return (
    <AiSearchChip
      onClick={handleStop}
      isGenerating={true}
      tooltipLabel="Stop AI Search"
    />
  );
};
